import { Box, Grid2, Typography } from "@mui/material";
import PrimarySlider from "Components/Common/PrimarySlider";
import React, { useState, useEffect, useContext } from "react";
import { SwiperSlide } from "swiper/react";
import { ReactComponent as AchievementIcon } from "Assets/Icons/Curriculum/Achievement.svg";
import { ReactComponent as NotRequiredIcon } from "Assets/Icons/Curriculum/NotRequiredIcon.svg";
import { ReactComponent as CompletedIcon } from "Assets/Icons/Curriculum/CompletedIcon.svg";
import { ReactComponent as ForwardIcon } from "Assets/Icons/Curriculum/ForwardIcon.svg";
import { ReactComponent as LockIcon } from "Assets/Icons/Home/LockIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DirectionContext } from "App";



const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  "& .moduleBox": {
    cursor: "pointer",
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    "& .innerBox": {
      border: `1px solid ${theme.palette.border.blue}`,
      borderRadius: "8px",
      padding: "8px",
    },
  },
  "& .active": {
    borderColor: theme.palette.primary.main,
    "& .title, .info": {
      color: theme.palette.primary.main,
    },
    "& .classActive, .interviewActive": {
      background: theme.palette.primary.main,
      "& p, span": {
        color: theme.palette.white.main,
      },
      "& svg": {
        fill: theme.palette.white.main,
      },
    },
  },
});

const ModulesList = () => {
  const { id, tab } = useParams();
  const navigate = useNavigate();

  const { direction } = useContext(DirectionContext);

  const { Modules, Translation } = useSelector((state) => ({
    Modules: state.Course.modules,
    Translation: state.Translation.translation?.Course || {},
  })); 

  const handleChangeModule = (id, type) => {
    navigate(`/core-curriculum/${id}/${type}`);
  };


  return (
    <Grid2 sx={styles}>
      <PrimarySlider
        slidesPerView={{
          1200: { slidesPerView: 4 },
          900: { slidesPerView: 4 },
          600: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
        spacing={"15px"}
      >
        {Modules?.map((item, i) => {
          return (
            <SwiperSlide key={i}>
              <Grid2
                key={`module${i}`}
                className={`moduleBox ${id == i ? "active" : ""}`}
                onClick={() => handleChangeModule(i, "classes")}
              >
                <Box display={"flex"} flexDirection={"column"} gap={"6px"}>
                  <Typography
                    className="title"
                    variant="subtitle"
                    fontWeight={500}
                  >
                    {`${Translation.Module} - ${i + 1}`}
                  </Typography>
                  <Typography
                    className="info"
                    color="secondary.light"
                    variant="subtitle"
                    fontWeight={500}
                  >
                    {item.ModuleName}
                  </Typography>
                  <Typography
                    display={"flex"}
                    alignItems={"center"}
                    gap="5px"
                    variant="body2"
                    color="secondary.light"
                  >
                    <PrimaryIcon icon={AchievementIcon} />
                    {item.ModuleDescription}
                  </Typography>
                </Box>
                <Box
                  className={`innerBox ${
                    tab == "classes" ? "classActive" : ""
                  }`}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  onClick={() => handleChangeModule(i, "classes")}
                >
                  <Typography variant="subtitle" fontWeight={500}>
                    {Translation?.Class}
                  </Typography>
                  <Typography display={"flex"} alignItems={"center"} gap="5px">
                    <PrimaryIcon
                      color={item.IsCompleted ? "success" : "primary"}
                      height="16px"
                      width="16px"
                      icon={item.ModuleStatus === 'Completed' ? CompletedIcon : item.ModuleStatus === 'InProgess' ? ForwardIcon : LockIcon}
                      flipX={direction === "rtl" && item.ModuleStatus === 'InProgess' ? true : false}
                    />{" "}
                    {Translation[item.ModuleStatus]}
                  </Typography>
                </Box>
                <Box
                  className={`innerBox ${
                    tab == "interview" ? "interviewActive" : ""
                  }`}
                  display={"flex"}
                  flexDirection={"column"}
                  gap="5px"
                  onClick={(e) => {
                    handleChangeModule(i, "interview");
                    e.stopPropagation();
                  }}
                >
                  {i % 2 == 0 ? (
                    <>
                      <Typography variant="subtitle" fontWeight={500}>
                        {Translation?.MockInterview}
                      </Typography>
                      <Typography
                        display={"flex"}
                        alignItems={"center"}
                        gap="5px"
                        color="secondary.light"
                      >
                        {Translation?.NotRequired}{" "}
                        <PrimaryIcon
                          fill={false}
                          height="14px"
                          width="14px"
                          icon={NotRequiredIcon}
                        />
                      </Typography>
                    </>
                  ) : (
                    <Typography
                      variant="subtitle"
                      color="error"
                      fontWeight={500}
                    >
                      {Translation?.MockInterviewPending}
                    </Typography>
                  )}
                </Box>
              </Grid2>
            </SwiperSlide>
          );
        })}
      </PrimarySlider>
    </Grid2>
  );
};

export default ModulesList;
